"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var astrocite_core_1 = require("astrocite-core");
var constants_1 = require("./constants");
var error_1 = require("./error");
var schema_1 = require("./schema");
var FIELD_TRANSFORMS = new Map([
    [
        'articleids',
        function (_a) {
            var articleids = _a.articleids, uid = _a.uid;
            return {
                URL: articleids.some(function (_a) {
                    var value = _a.value;
                    return value === uid;
                })
                    ? "https://www.ncbi.nlm.nih.gov/pubmed/" + uid
                    : "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC" + uid,
            };
        },
    ],
    [
        'authors',
        function (_a) {
            var authors = _a.authors;
            return {
                author: authors
                    .map(function (_a) {
                    var name = _a.name;
                    var _b = __read(name.split(' '), 2), family = _b[0], given = _b[1];
                    return __assign({ family: family || '' }, (given ? { given: given } : {}));
                })
                    .filter(function (_a) {
                    var family = _a.family;
                    return family !== '';
                }),
            };
        },
    ],
    [
        'lang',
        function (_a) {
            var lang = _a.lang;
            return {
                language: lang[0],
            };
        },
    ],
    [
        'sortdate',
        function (_a) {
            var sortdate = _a.sortdate;
            return {
                issued: astrocite_core_1.parseDate(sortdate),
            };
        },
    ],
    [
        'sortpubdate',
        function (_a) {
            var sortpubdate = _a.sortpubdate;
            return {
                issued: astrocite_core_1.parseDate(sortpubdate),
            };
        },
    ],
    [
        'source',
        function (_a) {
            var source = _a.source;
            return {
                journalAbbreviation: source,
                'container-title-short': source,
            };
        },
    ],
    [
        'uid',
        function (_a) {
            var articleids = _a.articleids, uid = _a.uid;
            var _b = articleids.find(function (i) { return i.value.endsWith(uid); }) || {}, _c = _b.idtype, idtype = _c === void 0 ? '' : _c, _d = _b.value, value = _d === void 0 ? uid : _d;
            switch (idtype) {
                case 'pubmed':
                case 'pmid':
                case '':
                    return { PMID: value };
                case 'pmc':
                case 'pmcid':
                    return { PMCID: value };
                default:
                    return {};
            }
        },
    ],
]);
var keys = Object.keys;
function parseEntry(entry) {
    if (schema_1.isError(entry)) {
        return new error_1.EUtilsError(entry.error, entry.uid);
    }
    return keys(entry).reduce(function (obj, key) {
        var _a;
        if (!entry[key]) {
            return obj;
        }
        var transform = FIELD_TRANSFORMS.get(key);
        if (transform) {
            return __assign({}, obj, transform(entry));
        }
        var cslKey = constants_1.FIELD_MAP.get(key);
        if (cslKey) {
            return __assign({}, obj, (_a = {}, _a[cslKey] = entry[key], _a));
        }
        return obj;
    }, {
        id: entry.uid,
        type: 'article-journal',
    });
}
function toCSL(_a) {
    var error = _a.error, result = _a.result;
    return __spread((error ? [new error_1.EUtilsError(error, true)] : []), result.uids.map(function (id) { return parseEntry(result[id]); }));
}
exports.toCSL = toCSL;
